import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSmoothScroll } from "./SmoothScroll";

// Strip the language prefix so /ar <-> /en switches are detected as "same page".
function pageKey(pathname) {
  return pathname.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
}

export default function ScrollToTop() {
  const location = useLocation();
  const { scrollToTop } = useSmoothScroll();
  const prevKey = useRef(pageKey(location.pathname));

  useEffect(() => {
    const currentKey = pageKey(location.pathname);
    const isLanguageSwitch = currentKey === prevKey.current;
    prevKey.current = currentKey;

    // Do not scroll on language switch or when navigating to an in-page anchor.
    if (isLanguageSwitch || location.hash) return;
    scrollToTop(true);
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash, scrollToTop]);

  return null;
}
